export default `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <path fill="#7C7C7C" d="M114.568,151.718l48.212-83.724c6.026-10.332-1.507-23.461-13.56-23.461H52.582c-12.054,0-19.587,12.914-13.561,23.461
            l48.427,83.724C93.476,162.049,108.542,162.049,114.568,151.718z"/>
</svg>`